import { useEffect, useState } from 'react';
import { skipToken } from '@reduxjs/toolkit/query';
import { config } from '../config';
import { useGetSlideThumbnailQuery } from '../services/slides.service';

export const useSlideThumbnailPolling = (
  thumbnailUrl: string | null | undefined,
  isHovered = false,
  themeId?: string | number | null,
) => {
  const [pollInterval, setPollInterval] = useState(0);

  const { data, isLoading, error } = useGetSlideThumbnailQuery(
    thumbnailUrl && isHovered ? { url: thumbnailUrl, themeId } : skipToken,
    { pollingInterval: pollInterval },
  );

  useEffect(() => {
    setPollInterval(data?.isGenerating && !error && isHovered ? config.defaultFetchInterval : 0);
  }, [data?.isGenerating, error, isHovered]);

  return {
    thumbnailUrl: data?.url ?? null,
    isLoading,
    isGenerating: data?.isGenerating ?? false,
    isError: !!error,
  };
};
